// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__k-6rd","whale":"NotFound_whale__hPk1Q","button":"NotFound_button__LZb2u","whale-img":"NotFound_whale-img__f8ZQv"};